import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from "react-google-maps"
import mapStyle from './../../assets/mapstyle.json';


const Map  = withScriptjs(withGoogleMap((props)=>{


    const {lat, lng} = props.location;

    return (
        <GoogleMap
            // defaultOptions={{ styles: mapStyle }}
            customMapStyle={mapStyle}
            defaultZoom={props.zoom || 12}
            defaultCenter={{ lat: lat, lng: lng }}
        >
            <Marker position={{ lat: lat, lng: lng }} />
        </GoogleMap>
    )
}));

class GoogleMapView extends React.Component {

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){

        if(!this.props.location) return null;

        return (
            <div className="GoogleMapView">
                <Map

                    isMarkerShown
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBVFAJJM-VC-mzou7pvcjvcbOAxNBdlUHo&v=3.exp&libraries=geometry,drawing,places"
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ width:`100%`, paddingTop:'100%', position : 'relative' }} />}
                    mapElement={<div style={{ position: 'absolute', top:0,left:0,right:0,bottom:0 }} />}
                    location={this.props.location}
                    zoom={this.props.zoom}
                ></Map>
            </div>

        )
    }
}

GoogleMapView.propTypes = {
    
}


export default GoogleMapView;


// WEBPACK FOOTER //
// ./src/components/common/GoogleMapView.js